import React, { useEffect, useRef , useState} from 'react';
import styled from 'styled-components'; 
import html2canvas from 'html2canvas';
import { htmlToCanvas, canvasToBase64, blobToBase64, compressImage } from 'utils/utils'
import { differenceInSeconds } from 'date-fns';
export default function ImageMergeProcessor({base64Images, width=1440, height=1440, domTemplate=[], onProcessing, onComplete, onError}) {
    const wrapper = useRef(null); 
    const [imgSrc, setImgSrc] = useState(null); 
    const [compressedImg, setCompressedImg] = useState(null);  
    const [time, setTime] = useState('');
    const [originTime, setOriginTime] = useState('');
    const [canvasTime, setCanvasTime] = useState('');
    const [rendered, setRendered] = useState(); 
    useEffect(() => { 
        const mergeImages = async () => {
            try
            {  
                console.log('base64');
                console.log(base64Images);
                if(Array.isArray(base64Images) && base64Images.length > 0)
                { 
                    if(onProcessing)
                    {
                        onProcessing();
                    }
                    const canvas = await htmlToCanvas(wrapper.current,{width: width,height: height, scale:1})   
                    const displayImg = await canvasToBase64(canvas)
                    if(onComplete)
                    {
                        onComplete(displayImg)
                    } 
                }
            }
            catch(err)
            {
                console.log(err);
                if(onError)
                {
                    onError()    
                }
            }
        }
        mergeImages();
    }, [base64Images])

    return ( 
            <Wrapper ref={wrapper} width={width} height={height}>  
                {(Array.isArray(base64Images) && base64Images.map((image,index)=>{ 
                    return(<TemplateWrapper key={`merge-images-${index}`} zIndex={(index+1)}>
                        <TemplateImg src={image} />
                    </TemplateWrapper>)
                }))}
            {domTemplate}
            </Wrapper> 
    )
}


const Wrapper = styled.div` 
    position:fixed; 
    left: 100%; 
    max-width : ${(props)=>props.width}px; 
    min-width : ${(props)=>props.width}px;
    max-height : ${(props)=>props.height}px; 
    min-height : ${(props)=>props.height}px;
` 
const TemplateWrapper = styled.div`
    position: absolute;
    top:0;
    bottom : 0;
    left:0;
    right:0;
    margin: auto;
    z-index: ${(props)=>props.zIndex};
`
const TemplateImg = styled.img`
    width : 100%;
    height: 100%;
    object-fit: cover;
` 